var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import { Controller } from 'react-hook-form';
import { Input } from '../../../infra/ui/input';
import Checkbox from '../../../../app/common/Checkbox';
export var ShopItem = function (props) {
    return (_jsxs("div", { className: "c-table-card__row c-table-card__row--transparent", children: [_jsx("div", { className: "c-table-card__cell u-1/10", children: _jsx(Controller, { control: props.form.control, name: "".concat(props.shop.id, ".enabled"), render: function (_a) {
                        var field = _a.field;
                        return (_jsx(Checkbox, { checked: field.value, onChange: field.onChange, onBlur: field.onBlur, name: field.name, inputRef: field.ref, loading: props.busy, inputClassName: cx({ 'is-indeterminate': !props.enabled }) }));
                    } }) }), _jsx("div", { className: "c-table-card__cell u-5/10", children: props.shop.name }), !!props.enabled && (_jsx("div", { className: "c-table-card__cell u-4/10", children: _jsx(Input, __assign({ className: "c-input", type: "number", step: "0.001", prefix: "%", placeholder: "Tax percentage" }, props.form.register("".concat(props.shop.id, ".percentage"), { valueAsNumber: true }), { error: props.percentageErrorMsg, disabled: !!props.readonly })) }))] }));
};
